var _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchIndeterminateO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9C1 4.58172 4.58172 1 9 1H21C25.4183 1 29 4.58172 29 9V9C29 13.4183 25.4183 17 21 17H9C4.58172 17 1 13.4183 1 9V9Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H21V0H9V2ZM21 16H9V18H21V16ZM9 16C5.13401 16 2 12.866 2 9H0C0 13.9706 4.02944 18 9 18V16ZM28 9C28 12.866 24.866 16 21 16V18C25.9706 18 30 13.9706 30 9H28ZM21 2C24.866 2 28 5.13401 28 9H30C30 4.02944 25.9706 0 21 0V2ZM9 0C4.02944 0 0 4.02944 0 9H2C2 5.13401 5.13401 2 9 2V0Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 20,
    y2: 9,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIndeterminateO);
export default __webpack_public_path__ + "static/media/switch-indeterminate-o.1af7409409ea8ca144aaa44fde12be9b.svg";
export { ForwardRef as ReactComponent };